import React, { useState, useCallback, useEffect } from "react";
import SearchBar from "./SearchBar";
import {
  getGridValidateCheck,
  saveGridCheckData,
  isFieldDisabled,
} from "../../../utils/validators";
import ButtonBar from "../../../components/Layout/ButtonBar";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalConfirm } from "../../../components/Confirm";
import useAuiGridMethods from "../../../hooks/AuiGrid/useAuiGridMethods";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import { columnLayout } from "./conlumnLayout";
import { INITIAL_FIELD_RULES } from "./validateFields";
import { useId } from "react-id-generator";
import osq from "../../../images/osq.png";
import SelectBox from "../../../components/SelectBox";
import useAppContext from "../../../utils/Reducers";

const GroupMng = (props) => {
  const [gridId] = useId(1, "aui-grid-");
  let auiGrid = useAuiGridMethods(gridId);
  const [state, setState] = useState("normaled");

  const {
    store: { userInfo, menuKey },
  } = useAppContext();

  useEffect(() => {
    auiGrid.resize("100%", "100%");
  }, [menuKey]);

  //추가, 수정일때 항목의 disabled 결정
  const disabledFields = {
    created: [],
    updated: ["groupId"],
  };

  const initItem = {
    groupId: "",
    groupNm: "",
    groupDesc: "",
    rmks: "",
    useYn: "",
    status: "",
  };
  const [fieldValues, setFieldValues] = useState(initItem);

  //그룹정보 검색 URL
  const SERARCH_GROUP_URL = "/common/group/searchGroupList.do";
  //그룹정보 저장 URL
  const SAVE_GROUP_URL = "/common/group/saveGroupList.do";
  //그룹정보 삭제 URL
  const DELETE_GROUP_URL = "/common/group/deleteGroupList.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SERARCH_GROUP_URL,
    },
    { manual: true }
  );

  const [primaryParameters, setPrimaryParameters] = useState({
    schGroupNm: "",
  });

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    auiGrid.create(columnLayout, { ...defaultGridProps });
    auiGrid.bind("cellClick", function (event) {
      gridCellClick(event.item);
    });

    //
  }, []);

  const gridCellClick = (item) => {
    // 추가 : editable, 수정 : edtiable, 삭제 : readonly
    //read
    //setFieldsEnabled(auiGrid, item, disabledFields);
    if (auiGrid.isAddedById(item._$uid)) {
      setState("created");
    } else if (auiGrid.isEditedById(item._$uid)) {
      setState("updated");
    } else if (auiGrid.isRemovedById(item._$uid)) {
      setState("deleted");
      //console.log("삭제 하는 항목");
    } else {
      setState("updated");
    }

    setFieldValues(item);
  };
  const handleMasterSearch = async () => {
    auiGrid.showAjaxLoader();
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_GROUP_URL,
      params: primaryParameters,
    });
    auiGrid.setGridData(data);
    setFieldValues(initItem);
    auiGrid.removeAjaxLoader();
  };

  const handleMasterNew = () => {
    //console.log(initItem);
    auiGrid.addRow(initItem, "last");
    setFieldValues(initItem);
    const items = auiGrid.getSelectedItems()[0];

    gridCellClick(items.item);
  };

  const handleMasterDelete = () => {
    auiGrid.removeRow("selectedIndex");
  };
  const handleMasterSave = async () => {
    if (
      await ModalConfirm({
        title: "저장",
        description: "데이터를 저장하시겠습니까?",
      })
    ) {
      let validator = [];

      var items = auiGrid.getGridData();

      const result = getGridValidateCheck(auiGrid, items, INITIAL_FIELD_RULES);
      if (result.isValidate) {
        document.getElementsByName(result.column)[0].focus();
        ModalConfirm({
          title: "필수항목체크",
          description: result.message,
          type: "alert",
        });
        auiGrid.setSelectionByIndex(result.rowIndex);
        gridCellClick(result.rowItem);
        return;
      }
      const addItems = auiGrid.getAddedRowItems();
      const editItems = auiGrid.getEditedRowItems();
      const removeItems = auiGrid.getRemovedItems();
      let param = saveGridCheckData(addItems, editItems, removeItems);
      if (param.length > 0) {
        const {
          data: { data },
        } = await fetchData({
          url: SAVE_GROUP_URL,
          data: param,
          method: "POST",
        });

        handleMasterSearch();
      } else {
        ModalConfirm({
          title: "필수항목체크",
          description: "저장할 항목이 없습니다. ",
          type: "alert",
        });
      }
    }
  };

  const handleChangeField = useCallback((event) => {
    //console.log(event);
    const { name, value } = event.target;
    const items = auiGrid.getSelectedItems()[0];
    const item = items.item;
    //console.log("name === " + name + " || value === " + value);

    item[name] = value;
    setFieldValues({ ...fieldValues, [name]: value });

    auiGrid.updateRow(item, "selectedIndex");
  });

  const handleMasterExcel = useCallback(() => {
    auiGrid.exportToXlsx({
      fileName: props.menuInfo.menuNmKor + " 리스트",
      exceptColumnFields: auiGrid.getHiddenColumnDataFields(),
    });
  });
  return (
    <>
      <ButtonBar
        menuInfo={props.menuInfo}
        handleMasterSearch={handleMasterSearch}
        handleMasterNew={handleMasterNew}
        handleMasterDelete={handleMasterDelete}
        handleMasterSave={handleMasterSave}
        handleMasterExcel={handleMasterExcel}
      />
      <SearchBar
        setSearchParameters={setPrimaryParameters}
        systemCd={userInfo.systemCd}
      />

      <div className="flexible_contents_box">
        <div className="databox">
          <div style={{ width: "100%", height: "100%" }}>
            <div id={gridId} style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
        <div className="databox">
          <div className="subdatabox">
            <h5>
              <img src={osq} /> &nbsp;그룹상세정보 &nbsp;
              <br />
            </h5>
            <ul className="t_form">
              <li className="doublehalf">
                <div className="title">
                  <span className="red">*</span>그룹아이디
                </div>
                <div className="formbox">
                  <input
                    id="groupId"
                    name="groupId"
                    disabled={isFieldDisabled(state, "groupId", disabledFields)}
                    value={fieldValues.groupId}
                    onChange={handleChangeField}
                    className="ip2"
                  />
                </div>
              </li>
              <li className="doublehalf">
                <div className="title">
                  <span className="red">*</span>그룹명
                </div>
                <div className="formbox">
                  <input
                    type="text"
                    id="groupNm"
                    name="groupNm"
                    style={{ width: "108px;" }}
                    disabled={isFieldDisabled(state, "groupNm", disabledFields)}
                    onChange={handleChangeField}
                    value={fieldValues.groupNm}
                    className="ip2"
                  />
                </div>
              </li>
              <li style={{ height: "75px" }}>
                <div className="title">설명</div>
                <div className="formbox">
                  <textarea
                    rows={1}
                    type="text"
                    id="groupDesc"
                    name="groupDesc"
                    disabled={isFieldDisabled(
                      state,
                      "groupDesc",
                      disabledFields
                    )}
                    onChange={handleChangeField}
                    value={fieldValues.groupDesc}
                    className="ip2"
                    style={{ height: "64px", verticalAlign: "middle" }}
                  />
                </div>
              </li>

              <li style={{ height: "75px" }}>
                <div className="title">비고</div>
                <div className="formbox">
                  <textarea
                    rows={1}
                    type="text"
                    id="rmks"
                    name="rmks"
                    disabled={isFieldDisabled(state, "rmks", disabledFields)}
                    onChange={handleChangeField}
                    value={fieldValues.rmks}
                    className="ip2"
                    style={{ height: "64px", verticalAlign: "middle" }}
                  />
                </div>
              </li>
              <li className="doublehalf">
                <div className="title">
                  <span className="red">*</span>사용여부
                </div>
                <div className="formbox">
                  <SelectBox
                    mastCd="USE_YN"
                    id="useYn"
                    name="useYn"
                    topSelected="전체"
                    disabled={isFieldDisabled(state, "useYn", disabledFields)}
                    onChange={handleChangeField}
                    value={fieldValues.useYn}
                    className="ip2"
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default GroupMng;
